import { API_ROOT } from 'environment';

angular.module('app.resources').factory('Inventory', ($q, $resource) =>
    $resource(`${API_ROOT}/inventory`)
);



// WEBPACK FOOTER //
// ./resources/inventory.js